module.exports = __webpack_public_path__ + "static/media/fd_logo.b37a9fc1.png";